// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PreviewVideo__video-c88b2c {
  display: flex;
  flex: 1;
  overflow: hidden;
  max-width: 100%;
  max-height: 100%;
  width: 100%;
  position: absolute;
  object-fit: cover;
  vertical-align: middle;
  transform: scale(-1, 1);
}`, "",{"version":3,"sources":["webpack://./../../packages/call/src/components/RoomCallPreviewVideo/PreviewVideo/PreviewVideo.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,OAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,uBAAA;AACF","sourcesContent":[".video {\n  display: flex;\n  flex: 1;\n  overflow: hidden;\n  max-width: 100%;\n  max-height: 100%;\n  width: 100%;\n  position: absolute;\n  object-fit: cover;\n  vertical-align: middle;\n  transform: scale(-1, 1);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"video": `PreviewVideo__video-c88b2c`
};
module.exports = ___CSS_LOADER_EXPORT___;
